<template>
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-md-4 col-6">
        <span class="titolo" v-if="!isEditing">{{ nome }}</span>
        <input type="text" v-else v-model="nome" />
      </div>

      <div class="col-md-6 col-12 order-3 order-md-2 ">
        <span class="descrizione" v-if="!isEditing">{{ descrizione }}</span>
        <input
          type="text"
          v-else
          @keyup.enter="handler"
          @focusout="handler"
          v-model="descrizione"
        />
      </div>

      <div class="col-md-2 col-6 order-md-3">
        <i
          v-if="isEditing"
          class="fas fa-check green pointer"
          @click="handler"
        ></i>
        <i
          v-else
          class="fas fa-pen orange pointer"
          @click="edit"
          title="Modifica"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index.vue",
  props: ["listino", "idListino"],
  data() {
    return {
      isEditing: false,
      nome: null,
      descrizione: null,
      successEdit: false,
    };
  },
  mounted() {
    this.nome = this.listino.nome;
    this.descrizione = this.listino.descrizione;
  },
  /*watch: {
    nome: function () {
    this.updateToDB()
    },
    descrizione: function () {
      this.updateToDB()
    },
  },*/
  methods: {
    handler: function () {
      this.update();
      this.updateToDB();
    },
    updateToDB: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "update_listino",
          id: this.idListino,
          nome: this.nome,
          descrizione: this.descrizione,
        },
      }).then((res) => {
        this.successEdit = true;
        this.$emit("refresh", true);
      });
    },
    update: function () {
      this.isEditing = false;
    },
    edit: function () {
      this.nome = this.listino.nome;
      this.descrizione = this.listino.descrizione;
      this.isEditing = !this.isEditing;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  margin: 20px 0;
  .titolo {
    font-size: 24px;
    display: block;
    width: 100%;
  }
  .input-titolo {
    font-size: 24px;
    width: 20%;
  }
  .descrizione {
    font-size: 18px;
  }
}
input {
  width: 100%;
}
.fas {
  font-size: 20px;
}
.fas.fa-pen {
  color: var(--dark-yellow);
}
.fas.fa-check {
  color: var(--dark-green);
}
.row {
  position: relative;
}
.messaggio-successo {
  position: absolute;
  display: inline-block;
  right: -50%;
  top: -100%;
}
</style>